"use client";

import { useBreakpointValue } from "@chakra-ui/react";
import {
  createContext,
  useContext,
  useMemo,
  type ReactNode,
} from "react";
import {
  getDashboardSidebarWidth,
} from "@/lib/layout/dashboard-sidebar";

interface DashboardSidebarContextValue {
  isCollapsed: boolean;
  sidebarOffset: string;
}

const DashboardSidebarContext =
  createContext<DashboardSidebarContextValue | null>(null);

interface DashboardSidebarProviderProps {
  children: ReactNode;
  isCollapsed: boolean;
}

export function DashboardSidebarProvider({
  children,
  isCollapsed,
}: DashboardSidebarProviderProps) {
  const sidebarOffset = useBreakpointValue({
    base: "0px",
    md: `${getDashboardSidebarWidth(isCollapsed)}px`,
  }) ?? "0px";

  const value = useMemo(
    () => ({ isCollapsed, sidebarOffset }),
    [isCollapsed, sidebarOffset],
  );

  return (
    <DashboardSidebarContext.Provider value={value}>
      {children}
    </DashboardSidebarContext.Provider>
  );
}

export function useDashboardSidebar() {
  const context = useContext(DashboardSidebarContext);

  return (
    context ?? {
      isCollapsed: false,
      sidebarOffset: "0px",
    }
  );
}
